<template>
  <div>
    <el-carousel
      ref="carousel"
      :autoplay="false"
      trigger="click"
      style="margin-top: 90px;"
      indicator-position="none"
      arrow="never"
    >
      <el-carousel-item>
        <div class="" style="display: flex; justify-content: center;">
          <el-card style="height: 250px; width: 500px;">
            <el-form>
              <el-form-item label="Will you be living on campus?">
                <el-input placeholder="Yes/No" v-model="options.campus"></el-input>
              </el-form-item>
              <p v-if="dummy === 'Yes'">
                The tuition for on campus students is $14,318.
              </p>
              <p v-else>The tuition for off campus students is $9818.</p>
            </el-form>
          </el-card>
        </div>
      </el-carousel-item>
      <el-carousel-item
        >Pell Grant
        <div class="" style="display: flex; justify-content: center;">
          <el-card style="height: 250px; width: 500px;">
            <el-form>
              <el-form-item
                label="What is your family's estimated net annual income?"
              >
                <el-input placeholder="USD" v-model="options.income"></el-input>
              </el-form-item>
              <p>
                84% of our students are Pell Grant recipients, which covers
                $5815.
              </p>
              <p>Cost Remaining: $8503</p>
              <p>Cost Remaining: $4003</p>
            </el-form>
          </el-card>
        </div></el-carousel-item
      >
      <el-carousel-item
        >Urban Scholars Program
        <div class="" style="display: flex; justify-content: center;">
          <el-card style="height: 250px; width: 500px;">
            <el-form>
              <el-form-item
                label="Do you plan on participating in the We Over Me Farm?"
              >
                <el-input placeholder="Yes/No" v-model="options.internships.farm"></el-input>
              </el-form-item>
              <!-- <p style="font-size: 10px;">
                Located in a food desert, the Farm has produced more than 30,000
                pounds of organic produce since its inception in March 2010, and
                no less than 10% of this produce has been donated to
                neighborhood charitable organizations. Under the guidance of the
                Farm Manager, the Farm is operated and maintained entirely by
                Paul Quinn student-employees, who actively engage in all farm
                activities, from business planning to marketing.
              </p> -->
              <el-form-item
                label="Do you plan on participating in the JPMC Summer Analyst Program?"
              >
                <el-input placeholder="Yes/No" v-model="options.internships.JPMC"></el-input>
              </el-form-item>
              <!-- <p>
                Students at Paul Quinn participate in the Work College program,
                which allows them to earn $6000. You'll be able to work 10-20
                hours per week, adding up to about 300-400 hours a year.
                Students can choose to work at 35 different work stations, both
                on and off campus, allowing them to gain valuable work
                experience before graduation. Some companies that students
                intern at include JP Morgan and NTT Data.
              </p> -->
            </el-form>
          </el-card>
        </div></el-carousel-item
      >
      <el-carousel-item
        >Graduation
        <div class="" style="display: flex; justify-content: center;">
          <el-card style="height: 250px; width: 500px;">
            <el-form>
              <el-form-item
                label="How many credits will you be completing in entirety?"
              >
                <el-input placeholder="Credits" v-model="options.credits"></el-input>
              </el-form-item>
            </el-form>
            <p>
              In one year, you only owe $1303. Students at Paul Quinn typically
              graduate with less than $10,000 in debt. In 2018, 49.6% of
              graduates graduated with no debt.
            </p>
          </el-card>
        </div></el-carousel-item
      >
      <el-carousel-item>
        <div class="" style="display: flex; justify-content: center;">
          <el-card style="height: 250px; width: 500px; display: flex; justify-content: center; align-items: center;">
            Based on your profile, your estimated final Investment in Yourself is <strong>${{ tuition }}</strong>
          </el-card>
        </div></el-carousel-item
      >
    </el-carousel>
    <div class="" style="display:flex; justify-content:center;">
      <el-steps :active="active" finish-status="success" style="width:75%" process-status="wait">
        <el-step title="Step 1"></el-step>
        <el-step title="Step 2"></el-step>
        <el-step title="Step 3"></el-step>
        <el-step title="Step 4"></el-step>
      </el-steps>
    </div>
    <div class="buttongroup">
      <el-button class="button" style="background-color:white; color: #44135a" @click="back">Back</el-button>
      <el-button class="button" @click="next">{{ message }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      message: "Next",
      dummy: "",
      tuition: 1412,
      options: {
        campus: "",
        credits: "",
        internships: {
          JPMC: "",
          farm: ""
        },
        income: ""
      }
    };
  },
  computed: {
    // tuition() {
    //   let options = this.options;
    //   let total;
    //   if (options.campus) {
    //     total = 14318;
    //   } else {
    //     total = 9818;
    //   }
    //   return 1412;
    // }
  },
  methods: {
    next() {
        this.dummy = ""
      if (this.message == "Calculate My Tuition") {
        this.active = 4;
        this.$refs.carousel.setActiveItem(this.active);
        return;
      }
      if (this.active == 3) {
        this.message = "Calculate My Tuition";
        return;
      }
      this.active++;
      this.$refs.carousel.setActiveItem(this.active);
    },
    back() {
        this.dummy = ""
      if (this.active-- == 0) this.active = 0;
      this.message = "Next";
      this.$refs.carousel.setActiveItem(this.active);
    }
  }
};
</script>

<style scoped>
.button {
    background-color: #44135a;
    margin-bottom: 15px;
    color: white;
    border-color: white;
}
.button:focus {
    background-color: #44135a;
    color: white;
    border-color: #44135a;
}
.button:hover {
    background-color: #44135a;
    color: white;
    border-color: #44135a;
}
</style>